import React, { PureComponent } from 'react'
import {
    BrowserRouter as Router,
    Route,
    Switch,
} from 'react-router-dom'

import CreateEdit from './CreateEdit'
import Search from './Search'
import CertificationStore from './store'

import './certification.scss'

class Certification extends PureComponent {
    constructor(props) {
        super(props)
        this.certificationStore = new CertificationStore(props.store)
        this.certificationStore.init()
    }

    render() {
        const { history: appHistory } = this.props

        return (
            <div>
                <Router>
                    <Switch>
                        <Route
                            path="/intranet/certification/:certificationId"
                            render={({ match, history }) => (
                                <CreateEdit
                                    store={this.certificationStore}
                                    certificationId={match.params.certificationId}
                                    history={history}
                                    match={match}
                                />
                            )}
                        />
                        <Route
                            path="/intranet/certification"
                            render={({ match, history }) => (
                                <Search
                                    store={this.certificationStore}
                                    appHistory={appHistory}
                                    history={history}
                                    match={match}
                                />
                            )}
                        />
                        <Route
                            render={() => (
                                <div>not found certification</div>
                            )}
                        />
                    </Switch>
                </Router>
            </div>
        )
    }
}

export default Certification
